var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.302,
    height: 79.126,
    viewBox: "0 0 57.302 79.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9872",
    "data-name": "Pfad 9872",
    d: "M123.491,173.157c-13.655-.024-18.3-9.431-18.311-23.087H99.156c0,16.987,7.352,29.345,24.335,29.345C123.573,179.47,123.517,173.16,123.491,173.157Zm-22.851-27.27s1.884-15.159-1.284-22.463c-4.744-10.928-19.275-19.359-19.275-19.359s-5.2,17.675.172,28.283A24.835,24.835,0,0,0,100.64,145.886Zm22.851-10.02c4.592-9.46.048-21.571.048-21.571s-11.98,3.252-16.567,12.716-.052,21.591-.052,21.591S118.891,145.354,123.491,135.867ZM83.225,144.4c-6.9.6-11.6,8.4-11.6,8.4s6.476,6.844,13.363,6.244,11.588-8.392,11.588-8.392S90.116,143.8,83.225,144.4Z",
    transform: "translate(-69.752 -101.807)",
    fill: "none",
    stroke: "#00488E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaves);
export default __webpack_public_path__ + "static/media/leaves.f532e3197daa5fa613c39648afbef915.svg";
export { ForwardRef as ReactComponent };